<script>
  import { valueModifies } from '@/utils'
  import _ from 'lodash'
  import mixins from './mixins'
  let numeral = require('numeral')
  export default {
    name: 'VInput',
    mixins: [mixins],
    render() {
      let value = _.get(this.row, this.column.prop)
      let format = this.config.format
      let className = ''
      if (this.config.type == 'number') {
        className = 'number'
        format = format ?? '0,0'
      }
      if (format) {
        value = numeral(value).format(format)
        value = value == 0 ? null : value
      }
      return (
        <ElFormItem
          prop={this.prop}
          rules={this.explainValidate()}
          label-width="0"
        >
          <ElInput
            class={className}
            value={value}
            onInput={(value) => {
              let val = value
              if (format) {
                val = numeral(val).value()
              }
              _.set(
                this.row,
                this.column.prop,
                valueModifies(this.config.modelModifiers, val)
              )
              if (this.config.onInput) {
                //解析prop 获取到父表的行索引，以及目前所在的行索引
                this.config.onInput(
                  this.tableRoot.tableData,
                  this.row,
                  this.column,
                  this.prop.split('.'),
                  value
                )
              }
            }}
          />
        </ElFormItem>
      )
    },
  }
</script>
